
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CssThemesService } from 'src/app/services/css-themes.service';
import { UserService } from 'src/app/services/user.service';
import * as _ from 'lodash';
import { Title } from '@angular/platform-browser';
import { environment as ENV } from '../../environments/environment';
import { IPolicies } from '../shared/models/policies.interface';
import { SspDataService } from './ssp-data-service';
import { emptyIEmail } from '../shared/models/email.interface';
import { ApiEndpoints } from 'src/config/api-endpoints';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SspService {

  constructor(
    private router: Router,
    private themeService: CssThemesService,
    private userService: UserService,
    private titleService: Title,
    private dataService: SspDataService,
    private http: HttpClient
  ) {

  }

  loadStyles() {
    this.userService.updateUserInfo({ type: 'self-service-portal' });
    this.themeService.loadSspStyle();
  }

  //Redirects to file a claim for current channel partner
  redirectToFileClaim(partner: string) {
    sessionStorage.setItem(`${partner}File`, "file");
    this.router.navigate([`/ssp/${partner}/file`]);
  }

  redirectToClaimsDashboard(partner: string) {
    this.router.navigate([`/ssp/${partner}/claims`]);
  }

  setLandingTitle(partner: string) {
    this.titleService.setTitle(`SSP | ${partner}`);
  }

  setFileTitle(partner: string) {
    this.titleService.setTitle(`SSP File Claim | ${partner}`);
  }

   //Returns request object for redirection to DPAT based on current channel partner
   getDpatRequest(policy: IPolicies, email: string, partner: string) {
    let shipmentInfo = this.dataService._channelPartnerShipmentDetails;
    let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails')); //UPSD-53665

    let request = {
      action: 'Get Started',
      paymentDirection: 'Claims',
      country: policyDetails?.policyCountry_Ext,
      paymentMode: '',
      policyIdentifier: policy.policyNumber ? policy.policyNumber : '',
      email: email,
      callBackURL: `${ENV.baseUrl.web}ssp/${partner}/file`,
      scenario: partner == 'ups-supply-chain-solutions' ? 'US' : 'SSP',
      createdByUserId: '',
      guestUserIndicator: "N",
      locale: sessionStorage.getItem('locale'),
      tupssFlow: '',
      //CUDAccess: partner == 'ups-supply-chain-solutions' ? true : false,
      CUDAccess: true,
      groupCode: email,
      policyData: {
        insured: policy.insured
      },
      iShipData: {
        companyName: shipmentInfo.shipperName ? shipmentInfo.shipperName : '', 
        email: email,
        phone: '',
        addressLine1: shipmentInfo.originAddress ? shipmentInfo.originAddress : '',
        addressLine2: '',
        city: shipmentInfo.originCity ? shipmentInfo.originCity : '',
        state: shipmentInfo.originState ? shipmentInfo.originState : '',
        zipCode: shipmentInfo.originPostalCode ? shipmentInfo.originPostalCode : '',
        payeeId: ""
      }
    }
    return request;
  }

  //Returns request object to send email for claim submission, for current CCP portal
  getClaimSubmissionEmailRequest(policyNumber: string, email: string, claimNumber: string, firstName: string, partner: string) {
    let shipmentInfo = this.dataService._channelPartnerShipmentDetails;
    let request = emptyIEmail;
    request = {
      ...request,
      emailFor: 'CCPClaimConfirmation',
      CountryLocale: sessionStorage.getItem('locale'),
      data: {
        email: email,
        claimNumber: claimNumber,
        // claimDetailLink: ENV.baseUrl.web + 'ssp/' + btoa(`${partner}/detail?policy=${policyNumber}&claimNumber=${claimNumber}&email=${email}`),
        claimDetailLink: ENV.baseUrl.web + btoa(`ssp/${partner}/detail?policyNumber=${policyNumber}&claimNumber=${claimNumber}&email=${email}`),
        firstName: firstName,
        companyName: shipmentInfo.consigneeName,
        streetAddress: shipmentInfo.destinationAddress,
        city: shipmentInfo.destinationCity,
        state: shipmentInfo.destinationState,
        zip: shipmentInfo.destinationPostalCode,
        lastName: '',
        channelPartnerName: partner,
        policyNumber: policyNumber,
        trackingNumber: shipmentInfo.trackingNumber,
        shipDate: shipmentInfo.shipDate
      }
    }
    return request;
  }

  getPartnerPolicy(request: any) {
    return this.http.post<any>(`${ENV.baseUrl.api}${ApiEndpoints.GET_PARTNER_POLICY}`, request);
  }

}
